import { Component, HostListener, OnInit } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-order-flow-admin-list',
  standalone: true,
  imports: [CommonModule, AgGridAngular],
  templateUrl: './order-flow-admin-list.component.html',
  styleUrl: './order-flow-admin-list.component.scss',
})
export class OrderFlowAdminListComponent {
  public viewPortSize: boolean = false;
  public rowData: any[] = [
    {
      orderId: 'ORD-1001',
      leadName: 'John Doe',
      service: 'Interior Design',
      assignedTo: 'Alice Smith',
      expDate: '2025-08-10',
      status: 'In Progress',
    },
    {
      orderId: 'ORD-1002',
      leadName: 'Emily Johnson',
      service: 'Renovation',
      assignedTo: 'Michael Brown',
      expDate: '2025-08-15',
      status: 'Pending',
    },
    {
      orderId: 'ORD-1003',
      leadName: 'Chris Lee',
      service: 'Architecture Planning',
      assignedTo: 'Samantha Davis',
      expDate: '2025-08-20',
      status: 'Approved',
    },
    {
      orderId: 'ORD-1004',
      leadName: 'Sophia Wilson',
      service: 'Electrical Work',
      assignedTo: 'James Wilson',
      expDate: '2025-08-22',
      status: 'In Progress',
    },
    {
      orderId: 'ORD-1005',
      leadName: 'Liam Martinez',
      service: 'Plumbing',
      assignedTo: 'Olivia Taylor',
      expDate: '2025-08-25',
      status: 'Rejected',
    },
  ];

  columnDefs: (
    | {
        headerName: string;
        field: string;
        flex: number;
        cellRenderer?: undefined;
        floatingFilter?: undefined;
        filter?: undefined;
      }
    | {
        field: string;
        headerName: string;
        flex: number;
        cellRenderer: (params: string) => HTMLDivElement;
      }
  )[];

  onCellClicked(params: any) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportSize();
  }

  checkViewportSize() {
    if (window.innerWidth > 1200) {
      this.viewPortSize = true;
    } else {
      this.viewPortSize = false;
    }
    this.setAGColumn();
  }

  setAGColumn() {
    this.columnDefs = [
      {
        headerName: 'Order ID',
        field: 'orderId',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Lead Name',
        field: 'leadName',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Service',
        field: 'service',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Assigned To',
        field: 'assignedTo',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Expected Date',
        field: 'expDate',
        flex: this.viewPortSize ? 1 : 0,
      },
      {
        headerName: 'Status',
        field: 'status',
        flex: this.viewPortSize ? 1 : 0,
        cellRenderer: (params: any): HTMLDivElement => {
          const value = params.value || '';
          const span = document.createElement('span');

          let color = '';
          switch (value.toLowerCase()) {
            case 'new':
              color = 'blue';
              break;
            case 'in progress':
              color = 'orange';
              break;
            case 'pending':
              color = 'purple';
              break;

            case 'approved':
              color = 'green';
              break;
            case 'rejected':
              color = 'red';
              break;
            default:
              color = 'black';
          }

          span.style.color = color;
          span.style.fontWeight = '500';
          span.innerText = value;

          // 👇 Required: Return a proper HTMLDivElement
          const div = document.createElement('div');
          div.appendChild(span);
          return div;
        },
      },
    ];
  }

  public defaultColDef: ColDef = {
    filter: 'agTextColumnFilter',
    floatingFilter: true,
  };
  public rowSelection: 'single' | 'multiple' = 'multiple';
  public paginationPageSize = 10;
  public paginationPageSizeSelector: number[] | boolean = [10];
  public themeClass: string = 'ag-theme-quartz';

  ngOnInit(): void {
    this.checkViewportSize();
  }


  fetchQuotations(pageSize: number = 10
  ) {
    // this.loading = true;
    // if (pageSize) {
    //   this.pageSize = pageSize;
    // }
    // const filter = {
    //   quoteStatus : this.parentQuoteStatus
    // }
    // const skip = this.page * this.pageSize;
    // const input = {
    //   search: this.search,
    //   limit: this.pageSize,
    //   filter,
    //   // advancedSearch: this.advancedSearch,
    //   startDate:this.startDate,
    //   endDate: this.endDate,
    //   skip,
    // }
    // this.quotationService
    //   .findAllQuotessWithPagination(input)
    //   .subscribe({
    //     next: (quotes) => {
    //       // this.totalPages = Math.ceil(
    //       //   (quotes?.total || quotes?.quotes?.length) / this.pageSize
    //       // );    
    //       this.rowData = (quotes?.quotes || []).map((quote: any) => {
    //         return {
    //           id: quote?.id,
    //           parentCode: quote?.parentCode || '--',
    //           quoteDate: this.datePipe.transform(
    //             quote?.quoteDate,
    //             'dd/MM/yyyy'
    //           ) || '--',
    //           quoteCode: quote?.quoteCode || '--',
    //           customerName: quote?.customerData?.firstName + ' ' + quote?.customerData?.lastName || '--',
    //           projectName: quote?.projectName || '--',
    //           // parentQuoteStatus: this.findStatus(quote?.quoteData[0]?.status),
    //           quoteStatus: quote?.quoteStatus || '--',
    //           totalAmount: quote?.totalAmount || '--',
    //           isEditable: quote?.isEditable,
    //         };
    //       });
    //       // this.loading = false;
    //     },
    //     error: (err) => {
    //       console.error('Error fetching journals:', err);
    //       this.toastr.error('Failed to fetch quotes');
    //       this.loading = false;
    //     // },
    //   });
  }
}
